import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="py-12 bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        {/* Brand */}
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 bg-signal-red flex items-center justify-center">
              <span className="font-black text-white text-sm">H</span>
            </div>
            <span className="font-heading font-bold text-lg tracking-tight text-white uppercase">
              High Wall Lift
            </span>
          </Link>
          <p className="text-gray-500 text-sm">
            Precision panel installation equipment for commercial construction.
          </p>
        </div>
        
        {/* Products */}
        <div>
          <h4 className="font-heading font-bold text-white uppercase text-sm mb-4">Products</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/products/buddy" className="text-gray-400 hover:text-white transition-colors text-sm" data-testid="footer-product-buddy">
                The Buddy™ (Model A) – Interior Material Hanger
              </Link>
            </li>
            <li>
              <Link to="/products/hank" className="text-gray-400 hover:text-white transition-colors text-sm" data-testid="footer-product-hank">
                The Hank™ (Model B) – IMP, Glass &amp; Building Envelope Hanger
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Resources */}
        <div>
          <h4 className="font-heading font-bold text-white uppercase text-sm mb-4">Resources</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/blog" className="text-gray-400 hover:text-white transition-colors text-sm" data-testid="footer-blog">
                Blog
              </Link>
            </li>
            <li>
              <a href="/#video" className="text-gray-400 hover:text-white transition-colors text-sm">
                Video Demo
              </a>
            </li>
            <li>
              <a href="/#gallery" className="text-gray-400 hover:text-white transition-colors text-sm">
                Gallery
              </a>
            </li>
          </ul>
        </div>
        
        {/* Contact */}
        <div>
          <h4 className="font-heading font-bold text-white uppercase text-sm mb-4">Contact</h4>
          <ul className="space-y-2">
            <li>
              <a href="tel:8067293701" className="text-gray-400 hover:text-white transition-colors text-sm" data-testid="footer-phone">
                (806) 729-3701
              </a>
            </li>
            <li>
              <a href="mailto:sales@highwalllift.com" className="text-gray-400 hover:text-white transition-colors text-sm" data-testid="footer-email">
                sales@highwalllift.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} High Wall Lift. All rights reserved.
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <Link to="/policies/shipping" className="text-gray-400 hover:text-signal-red transition-colors text-sm" data-testid="footer-policy-shipping">Shipping</Link>
          <Link to="/policies/returns" className="text-gray-400 hover:text-signal-red transition-colors text-sm" data-testid="footer-policy-returns">Returns &amp; Refunds</Link>
          <Link to="/policies/terms" className="text-gray-400 hover:text-signal-red transition-colors text-sm" data-testid="footer-policy-terms">Terms of Sale</Link>
          <Link to="/policies/privacy" className="text-gray-400 hover:text-signal-red transition-colors text-sm" data-testid="footer-policy-privacy">Privacy</Link>
          <a href="/#quote" className="text-gray-400 hover:text-signal-red transition-colors text-sm font-medium">
            Request Quote
          </a>
          <a href="/#contact" className="text-gray-400 hover:text-signal-red transition-colors text-sm font-medium">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
